// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Media parameters */
/* Colors */
/* Fonts */
.Header_header__LvPgI {
  padding: 16px 0;
  background-color: #FFFFFF;
  box-shadow: 0 2px 20px rgba(5, 0, 255, 0.2509803922);
}

.Header_inner__Smb22 {
  max-width: 1440px;
  margin: 0 auto;
  width: calc(100vw - 128px);
  display: flex;
  justify-content: space-between;
}
@media (max-width: 768px) {
  .Header_inner__Smb22 {
    width: calc(100vw - 16px);
  }
}

.Header_menu__3ALvd {
  display: flex;
}

.Header_menu-list__Zcho3 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 0;
  margin: 0;
  gap: 16px;
  list-style-type: none;
}
@media (max-width: 768px) {
  .Header_menu-list__Zcho3 {
    gap: 4px;
  }
}

.Header_menu-item__3hyJm {
  display: flex;
}

.Header_link__5FAWv {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #333333;
  text-decoration: none;
  padding: 8px 12px;
}
@media (max-width: 768px) {
  .Header_link__5FAWv {
    font-size: 12px;
    line-height: 110%;
    padding: 6px 10px;
  }
}
.Header_link__5FAWv:hover {
  color: #8000FF;
}
.Header_link--active__0O9mM {
  color: #FFFFFF;
  background-color: #8000FF;
  border-radius: 5px;
}
.Header_link--active__0O9mM:hover {
  color: #FFFFFF;
}

.Header_user-container__Yn6ca {
  display: flex;
  align-items: center;
}

.Header_logo__TheEq {
  display: flex;
  align-content: center;
  text-decoration: none;
  gap: 20px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/variables.sass","webpack://./src/components/header/Header.module.sass","webpack://./src/assets/styles/mixins.sass"],"names":[],"mappings":"AAAA,qBAAA;AASA,WAAA;AAWA,UAAA;ACjBA;EACI,eAAA;EACA,yBDKS;ECJT,oDAAA;AACJ;;AACA;ECOI,iBFZU;EEaV,cAAA;EACA,0BAAA;EDPA,aAAA;EACA,8BAAA;AAIJ;ACII;EDXJ;ICYQ,yBAAA;EDDN;AACF;;AAPA;EACI,aAAA;AAUJ;;AARA;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,qBAAA;AAWJ;AATI;EATJ;IAUQ,QAAA;EAYN;AACF;;AAXA;EACI,aAAA;AAcJ;;AAZA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cDxBS;ECyBT,qBAAA;EACA,iBAAA;AAeJ;AAbI;EARJ;ICpBI,eAAA;IACA,iBAAA;ID6BI,iBAAA;EAiBN;AACF;AAhBI;EACI,cD/BC;ACiDT;AAhBI;EACI,cDrCK;ECsCL,yBDnCC;ECoCD,kBAAA;AAkBR;AAhBQ;EACI,cD1CC;AC4Db;;AAhBA;EACI,aAAA;EACA,mBAAA;AAmBJ;;AAjBA;EACI,aAAA;EACA,qBAAA;EACA,qBAAA;EACA,SAAA;AAoBJ","sourcesContent":["/* Media parameters */\r\n$mobile-max: 768px\r\n$tablet-max: 1210px\r\n$desktop-max: 1440px\r\n\r\n// Отступы от краев экрана\r\n$mobile-offset: 8px\r\n$desktop-offset: 64px\r\n\r\n/* Colors */\r\n$base-white: #FFFFFF\r\n$base-black: #333333\r\n$base-shadow: #0500FF40\r\n$accent: #8000FF\r\n$accent-darken: #6000BF\r\n$link: #007AFF\r\n$error: #D60056\r\n// Также отвечает и за disabled\r\n$placeholder: #33333360\r\n\r\n/* Fonts */\r\n$fm-primary: 'Roboto Mono', 'Arial', monospace","@use \"../../assets/styles/variables\" as *\r\n@use \"../../assets/styles/mixins\" as mix\r\n\r\n.header\r\n    padding: 16px 0\r\n    background-color: $base-white\r\n    box-shadow: 0 2px 20px $base-shadow\r\n\r\n.inner\r\n    @include mix.container\r\n    display: flex\r\n    justify-content: space-between\r\n\r\n.menu\r\n    display: flex\r\n\r\n.menu-list\r\n    display: flex\r\n    flex-wrap: wrap\r\n    align-items: center\r\n    padding: 0\r\n    margin: 0\r\n    gap: 16px\r\n    list-style-type: none\r\n\r\n    @media (max-width: $mobile-max)\r\n        gap: 4px\r\n\r\n.menu-item\r\n    display: flex\r\n\r\n.link\r\n    display: flex\r\n    align-items: center\r\n    gap: 4px\r\n    color: $base-black\r\n    text-decoration: none\r\n    padding: 8px 12px\r\n\r\n    @media (max-width: $mobile-max)\r\n        @include mix.text-3\r\n        padding: 6px 10px\r\n\r\n    &:hover\r\n        color: $accent\r\n\r\n    &--active\r\n        color: $base-white\r\n        background-color: $accent\r\n        border-radius: 5px\r\n\r\n        &:hover\r\n            color: $base-white\r\n\r\n.user-container\r\n    display: flex\r\n    align-items: center\r\n\r\n.logo\r\n    display: flex\r\n    align-content: center\r\n    text-decoration: none\r\n    gap: 20px\r\n","@use \"./variables\" as *\r\n\r\n@mixin text-1\r\n    font-size: 20px\r\n    line-height: 120%\r\n\r\n@mixin text-2\r\n    font-size: 16px\r\n    line-height: 110%\r\n\r\n@mixin text-3\r\n    font-size: 12px\r\n    line-height: 110%\r\n\r\n@mixin container\r\n    max-width: $desktop-max\r\n    margin: 0 auto\r\n    width: calc(100vw - $desktop-offset * 2)\r\n\r\n    @media (max-width: $mobile-max)\r\n        width: calc(100vw - $mobile-offset * 2)\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header_header__LvPgI`,
	"inner": `Header_inner__Smb22`,
	"menu": `Header_menu__3ALvd`,
	"menu-list": `Header_menu-list__Zcho3`,
	"menu-item": `Header_menu-item__3hyJm`,
	"link": `Header_link__5FAWv`,
	"link--active": `Header_link--active__0O9mM`,
	"user-container": `Header_user-container__Yn6ca`,
	"logo": `Header_logo__TheEq`
};
export default ___CSS_LOADER_EXPORT___;
